"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSingleValue = exports.isPrintProviderEnabled = exports.getSalesman = exports.UserOption = exports.LocalStateTextInput = void 0;
var React = require("react");
var react_1 = require("react");
var Option_1 = require("react-select/lib/components/Option");
var sok_types_1 = require("@caddigital/sok-types");
var sok_ui_1 = require("@caddigital/sok-ui");
var avatars_1 = require("components/Avatar/avatars");
var LocalStateTextInput = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, type = _a.type, rows = _a.rows, placeholder = _a.placeholder, onChange = _a.onChange;
    var _b = (0, react_1.useState)(null), tempValue = _b[0], setTempValue = _b[1];
    var val = tempValue !== null ? tempValue : value;
    return (React.createElement(sok_ui_1.TextInput, { id: id, type: type, rows: rows, name: name, placeholder: placeholder, value: val, onChange: function (e) { return setTempValue(e.target.value); }, onBlur: function () {
            if (val !== value) {
                onChange(val);
                setTempValue(null);
            }
        } }));
};
exports.LocalStateTextInput = LocalStateTextInput;
var UserOption = function (props) { return (React.createElement(Option_1.default, __assign({}, props),
    React.createElement("div", { className: 'salesman-select-item' },
        React.createElement("img", { src: (0, avatars_1.getAvatarUrl)(props.data.avatar) }),
        React.createElement("div", { className: 'salesman-info' },
            React.createElement("div", null,
                props.data.firstName,
                " ",
                props.data.lastName),
            React.createElement("div", null, props.data.email))))); };
exports.UserOption = UserOption;
var getSalesman = function (props) {
    var id = props.step1.salesRepresentive
        ? props.step1.salesRepresentive.id
        : NaN;
    var found = props.salesman.list.find(function (s) { return s.id === id; });
    if (found) {
        return found;
    }
};
exports.getSalesman = getSalesman;
var isPrintProviderEnabled = function (features) {
    return (features.filter(function (feature) { return feature.constant === sok_types_1.Feature.PRINT_ORDERS && feature.enabled; }).length > 0);
};
exports.isPrintProviderEnabled = isPrintProviderEnabled;
var UserSingleValue = function (props) { return (React.createElement("div", { className: 'Select-value' },
    React.createElement("div", { className: 'Select-value-label salesman-value-label' },
        React.createElement("img", { src: (0, avatars_1.getAvatarUrl)(props.data.avatar) }),
        React.createElement("span", null,
            props.data.firstName,
            " ",
            props.data.lastName,
            " (",
            props.data.email,
            ")")))); };
exports.UserSingleValue = UserSingleValue;
